import React, { ReactNode } from 'react';
import { SelectElement } from './SelectField.styles';
import FeedbackError from '@/components/form/FeedbackError/FeedbackError';
import cx from 'classnames';
import HelperText from '@/components/form/HelperText/HelperText';

export interface SelectFieldProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  className?: string;
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  type?: React.InputHTMLAttributes<HTMLSelectElement>['type'];
  error?: string;
  children: ReactNode;
  sizing?: 'sm' | 'base' | 'lg';
  helperText?: string;
}

const SelectField = React.forwardRef<HTMLSelectElement, SelectFieldProps>(
  (
    {
      name,
      error,
      className,
      placeholder,
      onChange,
      children,
      sizing = 'base',
      helperText,
      ...props
    }: SelectFieldProps,
    ref
  ) => {
    return (
      <>
        <SelectElement
          ref={ref}
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          className={cx(
            {
              'is-invalid': error,
            },
            className
          )}
          sizing={sizing}
          {...props}
        >
          {children}
        </SelectElement>
        <FeedbackError error={error} />
        <HelperText text={helperText} />
      </>
    );
  }
);

SelectField.displayName = 'SelectField';

export default SelectField;
